import type { UseOrderTicketControllerReturn } from "../OrderTicket.controller";
import { useEquityOrderTicketController } from "./EquityOrderTicket.controller";
import { EquityOrderTicketPresentation } from "./EquityOrderTicket.pres";

export interface EquityOrderTicketConnectorProps
  extends Omit<
    UseOrderTicketControllerReturn,
    | "contract"
    | "isContractSymbol"
    | "isCryptoSymbol"
    | "onSymbolChange"
    | "isSymbolInputAutoFocus"
  > {
  AssetSearch: JSX.Element;
  fill?: boolean;
  initialQuantity?: number;
}

export const EquityOrderTicketConnector = ({
  product,
  account,
  margin,
  positions,
  symbol,
  quote,
  refetchQuote,
  asset,
  clock,
  AssetSearch,
  feedLabel,
  fill,
  initialQuantity,
}: EquityOrderTicketConnectorProps) => {
  const props = useEquityOrderTicketController({
    account,
    product,
    asset,
    margin,
    positions,
    quote,
    symbol,
    clock,
    initialQuantity,
  });

  return (
    <EquityOrderTicketPresentation
      asset={asset}
      quote={quote}
      symbol={symbol}
      feedLabel={feedLabel}
      onRefreshQuoteClicked={refetchQuote}
      AssetSearch={AssetSearch}
      fill={fill}
      {...props}
    />
  );
};
